import React,{useState} from "react";
import { useParams, Link } from "react-router-dom";

function Header() {
  const { nation } = useParams();
  const [len, setLen] = useState(false);
  return (
    <header>
      <div className="wrap">
        <a href="/" id="logo">
          <img src={`/image/${nation}Logo.svg`} alt="" />
        </a>
      </div>
      <div className="lenList">
        <i class="fas fa-globe-americas" onClick={()=>{setLen(!len)}}></i>
        <ul className={len == true ? "on" : ""}>
          <li><Link to="/detail/en/COMPANY/1" onClick={()=>{setLen(false)}}>EN</Link></li>
          {/* <li><Link to="/detail/ru/Компания/1" onClick={()=>{setLen(false)}}>RU</Link></li> */}
          <li><Link to="/detail/Hindi/कंपनी/1" onClick={()=>{setLen(false)}}>Hindi</Link></li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
